export default __webpack_public_path__ + "static/media/marauders-map-v3-04-04.f57fc2b2.jpg";